import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import Minimize from "../resources/Minimise.png.js";
import Close from "../resources/CloseIcon.png.js";
import ChatIcon from "../resources/ChatIcon.png.js";
const ChatHeader = (props) => {
  return /* @__PURE__ */ jsxs("div", { id: "chat-header", className: "light-red-gradient", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      "Let's Chat",
      " ",
      /* @__PURE__ */ jsx("img", { alt: "Chat Bubble", src: ChatIcon, className: "lets-chat-image" })
    ] }),
    /* @__PURE__ */ jsxs("div", { id: "minimize-button", children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: Minimize,
          onClick: props.onMinimizeClick,
          alt: "Minimize Chat",
          title: "Minimize Chat"
        }
      ),
      props.showCloseButton ? /* @__PURE__ */ jsx(
        "img",
        {
          src: Close,
          onClick: props.onCloseClick,
          alt: "End Chat",
          title: "End Chat"
        }
      ) : null
    ] })
  ] });
};
ChatHeader.propTypes = {
  businessUnit: PropTypes.number,
  showCloseButton: PropTypes.bool,
  onMinimizeClick: PropTypes.func,
  onCloseClick: PropTypes.func
};
export {
  ChatHeader as default
};
//# sourceMappingURL=ChatHeader.js.map
